<template>
    <div class="widthBox">
        <div v-if="xs">
            <el-row :gutter="10" class="acea-row mb_80" :class="index == 0 ? 'mb_120' :''" v-for="(item,index) in about_us_list" :key="index">
                <el-col :span="11" :xs="24" class="mb_40" v-if="item.image_url_list.length == 1">
                    <div><img class="img100 radius-8" :src="item.image_url_list[0]" alt=""></div>
                </el-col>
                <div class="hidden-sm-and-up mt_40 mb_20" :xs="24"  v-if="item.image_url_list.length == 2">
                        <el-col :xs="12" class="mt_40" style="padding: 0;padding-right: 5px;">
                            <div><img class="img100 radius-8" :src="item.image_url_list[0]" alt=""></div>
                        </el-col>
                        <el-col :xs="12" class="" style="padding: 0;padding-bottom: 36px;padding-left: 5px;">
                            <div><img class="img100 radius-8" :src="item.image_url_list[1]" alt=""></div>
                        </el-col>
                    </div>
                <el-col :xs="24" class="hidden-sm-and-up mt_16">
                    <div class="txt f-28 mb_20" v-if="item.name">{{ item.name}} </div>
                    <div class="mb_20" v-if="index == 0"><img src="@/assets/line.png" alt=""></div>
                    <div class="info mb_20" v-if="item.desc">{{ item.desc }} </div>
                </el-col>
                <el-col :xs="24" class="hidden-sm-and-up" v-if="item.instruction_list.length !=0 && item.instruction_list[0].name != '' &&  item.instruction_list[0].value != ''">
                   <div v-for="item2 in item.instruction_list" :key="item2.name">
                    <div class="info mb_20 f-20">{{ item2.name }} </div>
                    <div class="info2 mb_40">{{ item2.value }}</div>
                 
                   </div>
                    
                </el-col>
            </el-row>
        </div>
        <div v-else>
                <div class="acea-row mb_80" :class="index == 0 ? 'mb_120' :''" v-for="(item,index) in about_us_list" :key="index">
                    <div v-if="index%2 == 0" class="flex">
                        <div class="mb_40" style="width: auto;margin-right: 20px;max-width: 50%;" v-if="item.image_url_list.length == 1">
                            <div><img class="img100 radius-8" :src="item.image_url_list[0]" alt=""></div>
                        </div>
                        <div class="mt_40 mb_20 flex"  style="width: auto;margin-right: 20px;max-width: 50%;align-items: flex-start;" v-if="item.image_url_list.length == 2">
                            <div class="mt_40" style="padding: 0;padding-right: 5px;width: 48%;">
                               <div><img class="img100 radius-8" :src="item.image_url_list[0]" alt=""></div>
                            </div>
                            <div class="" style="padding: 0;padding-bottom: 36px;padding-left: 5px;width: 48%;">
                               <div><img class="img100 radius-8" :src="item.image_url_list[1]" alt=""></div>
                            </div>
                        </div>
                        <div style="flex: 1;">
                            <div class="mt_16">
                                <div class="txt f-28 mb_20" v-if="item.name">{{ item.name}} </div>
                                <div class="mb_20" v-if="index == 0"><img src="@/assets/line.png" alt=""></div>
                                <div class="info mb_20" v-if="item.desc">{{ item.desc }} </div>
                            </div>
                            <div class="" v-if="item.instruction_list.length !=0 && item.instruction_list[0].name != '' &&  item.instruction_list[0].value != ''">
                                <div v-for="item2 in item.instruction_list" :key="item2.name">
                                    <div class="info mb_20 f-20">{{ item2.name }} </div>
                                    <div class="info2 mb_40">{{ item2.value }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="flex">
                        <div style="flex: 1;">
                            <div class="mt_16">
                                <div class="txt f-28 mb_20" v-if="item.name">{{ item.name}} </div>
                                <div class="mb_20" v-if="index == 0"><img src="@/assets/line.png" alt=""></div>
                                <div class="info mb_20" v-if="item.desc">{{ item.desc }} </div>
                            </div>
                            <div class="" v-if="item.instruction_list.length !=0 && item.instruction_list[0].name != '' &&  item.instruction_list[0].value != ''">
                                <div v-for="item2 in item.instruction_list" :key="item2.name">
                                    <div class="info mb_20 f-20">{{ item2.name }} </div>
                                    <div class="info2 mb_40">{{ item2.value }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="mb_40" style="width: auto;margin-left: 20px;max-width: 50%;" v-if="item.image_url_list.length == 1">
                            <div><img class="img100 radius-8" :src="item.image_url_list[0]" alt=""></div>
                        </div>
                        <div class="mt_40 mb_20 flex"  style="width: auto;margin-left: 20px;max-width: 50%;align-items: flex-start;" v-if="item.image_url_list.length == 2">
                            <div class="mt_40" style="padding: 0;padding-right: 5px;width: 48%;">
                               <div><img class="img100 radius-8" :src="item.image_url_list[0]" alt=""></div>
                            </div>
                            <div class="" style="padding: 0;padding-bottom: 36px;padding-left: 5px;width: 48%;">
                               <div><img class="img100 radius-8" :src="item.image_url_list[1]" alt=""></div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"OurStory",
    data(){
        return{
            about_us_list:[],
            xs:false
        }
    },
    created(){
        this.get_info();
		if (window.innerWidth < 768) {
			this.xs = true
		}
    },
    methods:{
        async get_info(){
            let res = await this.$api.get("api/AboutUs/index");
            this.about_us_list = res.data.about_us_list;
        }
    }


}
</script>

<style lang="scss" scoped="scoped">
    .flex{
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
    }
    .mt_16{
        margin-top: 16px;
    }
    .mt_40{
        margin-top: 40px;
    }

    .mt_80{
        margin-top: 80px;
    }    .mb_120{
        margin-bottom: 120px;
    }
    .mb_80{
        margin-bottom: 80px;
    }
    .mb_40{
        margin-bottom: 40px;
    }
    .mb_20{
        margin-bottom: 20px;
    }
    .info2 {
        font-size: 14px;
    }
    .info,.info2{
        line-height: 24px;
    }
    
@media screen and(max-width:768px) {
    .mt_16{
        margin-top: 16px;
    }
    .mt_40{
        margin-top: 20px;
    }

    .mt_80{
        margin-top: 40px;
    }    
    .mb_120{
        margin-bottom: 56px;
    }
    .mb_80{
        margin-bottom: 32px;
    }
    .mb_40{
        margin-bottom: 20px;
    }
    .mb_20{
        margin-bottom: 12px;
    }

}
</style>
